import { render, staticRenderFns } from "./trainingInstitutionList.vue?vue&type=template&id=5f7cc7cd&scoped=true&"
import script from "./trainingInstitutionList.vue?vue&type=script&lang=js&"
export * from "./trainingInstitutionList.vue?vue&type=script&lang=js&"
import style0 from "./trainingInstitutionList.vue?vue&type=style&index=0&id=5f7cc7cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7cc7cd",
  null
  
)

export default component.exports